import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, take, map, timeout, catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AccountSelectedGuard implements CanActivate {
    constructor(private auth: AuthService, private router: Router) { }

    canActivate(): Observable<boolean | UrlTree> {
        // si NO hay cuenta elegida → ir al selector
        if (!this.auth.account_key) {
            return of(this.router.createUrlTree(['/admin/accounts']));
        }

        // hay cuenta elegida → esperar a que esté cargada
        return this.auth.isAccountAvailable.pipe(
            filter(v => v === true),      // 👈 SOLO cuando sea true
            take(1),
            map(() => true),
            timeout(10000),               // para no quedar colgado si algo falla
            catchError(() => of(this.router.createUrlTree(['/admin/accounts'])))
        );
    }
}